// Types
export const INSERIR_DADOS_EMPRESA = "empresa/INSERIR_DADOS_EMPRESA";
export const INSERIR_LISTA_EMPRESAS_HELP = "empresa/INSERIR_LISTA_EMPRESAS_HELP";

// Reducer
export const INITIAL_STATE = {
  empresa: null,
  listaEmpresasHelp: []
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case INSERIR_DADOS_EMPRESA:
      return {
        ...state,
        empresa: action.payload
      };
    case INSERIR_LISTA_EMPRESAS_HELP:
      return {
        ...state,
        listaEmpresasHelp: action.payload
      };
    default:
      return state;
  }
}

// Action creators
export const inserirDadosEmpresa = empresa => {
  return {
    type: INSERIR_DADOS_EMPRESA,
    payload: empresa
  };
};

export const inserirListaEmpresasHelp = empresas => {
  return {
    type: INSERIR_LISTA_EMPRESAS_HELP,
    payload: empresas
  };
};
